import type { ShapeText } from "../types";

/**
 * Rotation (degrés, sens horaire depuis le nord) d'un texte posé au sol : la sienne, sinon celle du
 * texte normal (dont hérite le texte au survol), sinon `defaultRotationDeg`. Aucune s'il reste à l'endroit.
 */
export function shapeTextRotationDeg(
  text: ShapeText | undefined,
  normalText: ShapeText | undefined,
  upright: boolean,
  defaultRotationDeg: number,
): number {
  if (upright) return 0;

  return text?.rotation ?? normalText?.rotation ?? defaultRotationDeg;
}

/** Cap (0–360) de la vue de départ : l'opposé de sa `rotationDeg` (voir `showStartView`). */
export function startViewBearingDeg(startRotationDeg: number): number {
  return (((-startRotationDeg) % 360) + 360) % 360;
}
